import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import { budgetData } from 'pages/Budget';
import { needData } from 'pages/NeedCar';
import { experienceData } from 'pages/Experience';
import { monthlyData } from 'pages/Mounthly';


import './styles.scss';

const Answers = ({ isOpen, backHand, user }) => (
  <Modal isOpen={isOpen}>
    <div className="modal-answer">
      <ModalHeader backHandl={backHand}>
        Answers
      </ModalHeader>

      <ul className="answer-list">
        <li className="answer-item">
          <span>
            monthly budget
          </span>
          <b>
            { budgetData[user.userMonthlyBudget] || '-'}
          </b>
        </li>
        <li className="answer-item">
          <span>
            why you need a car
          </span>
          <b>
            { user.whyUserNeedCar.length ? user.whyUserNeedCar.map((el, index, arry) =>
                `${needData[el]}${arry.length - 1 !== index ? ', ' : ''}`) : '-'}
          </b>
        </li>
        <li className="answer-item">
          <span>
            birthday date
          </span>
          <b>
            { user.birthDay && user.birthDay !== '' ? moment(user.birthDay).format('DD.MM.YYYY') : '-'}
          </b>
        </li>
        <li className="answer-item">
          <span>
            birthday date
          </span>
          <b>
            { user.gender ? 'Man' : 'Women'}
          </b>
        </li>
        <li className="answer-item">
          <span>
            working
          </span>
          <b>
            { user.workingStatus ? 'Yes' : 'No'}
          </b>
        </li>
        {
            user.workingStatus ? (
              <React.Fragment>
                <li className="answer-item">
                  <span>
                    working experience
                  </span>
                  <b>
                    { experienceData[user.workingExperience] || '-'}
                  </b>
                </li>
                <li className="answer-item">
                  <span>
                    monthly income
                  </span>
                  <b>
                    { monthlyData[user.monthlyIncome] || '-'}
                  </b>
                </li>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <li className="answer-item">
                  <span>can give down payment
                  </span>
                  <b>
                    { user.minDownPaymentAgreeOrNot ? 'Yes' : 'No'}
                  </b>
                </li>
              </React.Fragment>

            )
        }
        <li className="answer-item">
          <span>
                What down payment you have available?
          </span>
          <b>
            { monthlyData[user.downPaymentsAviable] || '-'}
          </b>
        </li>


        <li className="answer-item">
          <span>
            can confirm income
          </span>
          <b>
            { user.confirmMonthlyIncome ? 'Yes' : 'No'}
          </b>
        </li>
      </ul>
    </div>
  </Modal>
);

Answers.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  backHand: PropTypes.func.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object
};


export default Answers;



// WEBPACK FOOTER //
// ./src/pages/Profile/components/Answers/index.js